<template>
<v-row wrap>

    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card v-if="selectuser != null">
            <v-card-title>
                <span class="headline">Edit Room</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Name*" v-model="roomname" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Location*" v-model="roomlocation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field label="capacity*" v-model="roomcapacity"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-switch v-model="roomstatus" value="Ready" inset :label="`room status`"></v-switch>
                        </v-col>

                    </v-row>
                </v-container>
                <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
                <!-- <v-btn color="red" v-if='!deleteuserbtn' dark @click="deleteuserbtn = true">
                    DELETE USER
                </v-btn>
                <v-btn color="red" text v-if='deleteuserbtn' dark @click="deleteuserbtn = false">
                    cancel
                </v-btn>
                <v-btn color="red" v-if='deleteuserbtn' dark @click="deleteuser">
                    confirm
                </v-btn> -->
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                    Close
                </v-btn>
                <v-btn color="blue darken-1" v-if='!adduserprofile' text @click="updateroom">
                    Save
                </v-btn>
                <v-btn color="blue darken-1" v-if='adduserprofile' text @click="add">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-col cols="12">
        <v-row justify="center" style="padding-top:5vh">

            <v-col cols="12">
                <div class="text-start">
                    <!-- <v-btn rounded color="primary" dark>
                        <v-icon right dark>
                            mdi-cloud-upload
                        </v-icon>Add user
                    </v-btn> -->

                    <!-- <v-btn tile rounded color="success" @click="adduser">
                        <v-icon left>
                            mdi-plus-circle
                        </v-icon>
                        Add meetingroom
                    </v-btn> -->
                </div>
            </v-col>
            <v-card>

                <v-card-title v-if="data.showtable" width="100%">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table v-if="data.showtable" width="500" :headers="header" :items="data.datatable" :items-per-page="6" 
                :footer-props="{ 'items-per-page-options': [6,9]}" :search="search" class="elevation-1 ">

                    <template v-slot:item.room_status_desc="{ item }">
                        <v-chip v-if="item.room_status_desc === 'Ready'" color="light-green darken-1" dark>
                            {{ item.room_status_desc }}
                        </v-chip>
                        <v-chip v-if="item.room_status_desc === 'Close'" color="deep-orange darken-3" dark>
                            {{ item.room_status_desc }}
                        </v-chip>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <!-- <v-menu > -->
                        <v-btn fab icon small @click="editItem(item)">
                            <v-icon color="light-blue accent-4">
                                mdi-dots-horizontal
                            </v-icon>
                        </v-btn>

                        <!-- </v-menu> -->
                    </template>

                </v-data-table>
            </v-card>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import {
    Data
} from '../models'
import {
    mapState,
    dispatch,
    mapActions,
    store
} from 'vuex'
export default {
    data() {
        return {
            roomname: null,
            roomlocation: null,
            roomcapacity: null,
            roomstatus: null,

            adduserprofile: false,
            deleteuserbtn: false,
            typeuser: ['admin', 'user', ],
            selectuser: null,
            dialog: false,
            search: '',
            firstname: null,
            lastname: null,
            email: null,
            phone: null,
            dialogtext: null,
            switch2: false,

            header: [{
                    "text": "Name",
                    "value": "name",
                    width: '120',
                },
                {
                    "text": "Location",
                    "value": "room_location",
                    width: '200',
                },
                {
                    "text": "Capacity",
                    "value": "capacity",
                    width: '200',
                    align: 'center'
                },
                {
                    "text": "status",
                    "value": "room_status_desc",
                    width: '120',
                },
                {
                    "text": "Action",
                    "value": "action",
                    width: '100',
                    sortable: false
                }
            ],
        }
    },

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
        },
        ...mapState('datas', {
            data: 'data'
        }),
    },

    created() {
        // this.$store.dispatch("datas/getbooking")
        this.$store.dispatch("datas/getlistroom")
    },

    methods: {
        editItem(item) {
            this.selectuser = item
            // console.log(this.selectuser)
            this.dialog = true
            this.roomname = item.name
            this.roomlocation = item.room_location
            this.roomcapacity = item.capacity
            this.roomstatus = item.room_status_desc
        },
        confirm() {
            let payload = new FormData()
            let status
            if (this.booking.booking_status == "booking") {
                status = "cancel"
            } else if (this.booking.booking_status == "cancel") {
                status = "booking"
            }
            payload.append('booking_id', this.booking.booking_id)
            payload.append('status', status)
            this.$store.dispatch("datas/changebookingstatus", payload)
            // console.log(this.booking)
            this.dialog = false
        },
        updateroom() {
            let payload = new FormData()
            payload.append('room_id', this.selectuser.room_id)
            payload.append('name', this.roomname)
            payload.append('room_location', this.roomlocation)
            payload.append('capacity', this.roomcapacity)
            if(this.roomstatus != null){
                payload.append('room_status_id', '1')
            }
            if(this.roomstatus == null){
                payload.append('room_status_id', '3')
            }
            this.$store.dispatch("datas/updateroom", payload)
            this.dialog = false
            this.selectuser = null
        },
        deleteuser() {
            console.log("delete")
            let payload = new FormData()
            payload.append('user_id', this.selectuser.user_id)
            this.$store.dispatch("datas/deleteuser", payload)
            this.dialog = false
            this.selectuser = null
        },
        adduser() {
            this.selectuser = []
            this.selectuser.email = null
            this.selectuser.firstname = null
            this.selectuser.lastname = null
            this.selectuser.phone = null
            this.selectuser.timelimit = null
            this.selectuser.type = null
            this.dialog = true
            this.adduserprofile = true
        },
        add() {
            this.adduserprofile = false
            let payload = new FormData()
            payload.append('firstname', this.selectuser.firstname)
            payload.append('lastname', this.selectuser.lastname)
            payload.append('email', this.selectuser.email)
            payload.append('phone', this.selectuser.phone)
            payload.append('timelimit', this.selectuser.timelimit)
            payload.append('type', this.selectuser.type)
            this.$store.dispatch("datas/adduser", payload)
            this.dialog = false
        }

    },
}
</script>

<style>

    </style>
